module.exports = __webpack_public_path__ + "img/9788981337155.a857577e.jpg";